// import dynamic from "next/dynamic";
// const { JSEncrypt } = dynamic(() => import("jsencrypt"), {
//   ssr: false,
// });
import { Util, Platform, Bridge, XtLocale } from "@xt/xtbase";
import copy2 from "copy-to-clipboard";
import localeMap from "@/locales/map";
import { Cookie } from "@xt/xtbase";
import { get_tdk } from "api/server/tdk";
import { useEffect, useMemo } from "react";
import { useStore } from '@/models';
const { Big } = Util;

/**
 * 根据当前顶级域名，获取二级域名链接
 * @param api，对应二级域名字符串，为空时返回顶级域名
 * @param noProtocol，获取链接默认是带有协议的，如果该字段存在，不包含协议
 *     如果 noProtocol === "ws" 会更加当前http协议添加 ws:// 或 wss://
 */
export function getOrigin(api, noProtocolOrWs) {
  let host, protocol;
  if (typeof window === "undefined") {
    //server side
    host = process.env.NEXT_PUBLIC_host;
    protocol = process.env.NEXT_PUBLIC_protocol;
  } else {
    const isLocal =
      location.hostname === "localhost" ||
      /^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)(\.(?!$)|$)){4}$/.test(
        location.hostname
      );
    host = isLocal ? process.env.NEXT_PUBLIC_host : location.host;
    protocol = isLocal ? process.env.NEXT_PUBLIC_protocol : location.protocol;
  }

  const topDomain = host.split(".").slice(-2).join(".");
  const domain = (api ? `${api}.` : "") + topDomain;
  if (!noProtocolOrWs) return `${protocol}//` + domain;

  if (typeof noProtocolOrWs === "object") {
    if (noProtocolOrWs.ws) {
      return `${protocol.includes("https") ? "wss" : "ws"}://` + domain;
    }
    if (noProtocolOrWs.noProtocol) {
      return domain;
    }
  }

  if (noProtocolOrWs === "ws")
    return `${protocol.includes("https") ? "wss" : "ws"}://` + domain;
  return domain;
}

/**
 * 正则表达式校验
 * @param type，验证类型，譬如：email 邮箱
 * @param content，需要验证的字符串
 * @param retRegExp，可选，如果存在，返回正则表达式
 * @returns，Boolean 是否匹配，或是是正则表达式
 */
export function regexp(type, content, retRegExp) {
  const verify = {
    email: /^([a-zA-Z0-9_\.-])+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\.)+[a-zA-Z]{2,}$/,
    phone: /^[0-9]{5,11}$/,
    loginPassword: /^(?=.*[0-9].*)(?=.*[A-Z].*).{8,1000}$/,
    securityPassword:
      /^(?![\d]+$)(?![a-zA-Z]+$)(?![!@#\$%\^&\*\(\)]+$)[\da-zA-Z!@#\$%\^&\*\(\)]{6,20}$/,
    securityPassword2:
      /^(?![\d]+$)(?![a-zA-Z]+$)(?![!@#\$%\^&\*\(\)]+$)[\da-zA-Z!@#\$%\^&\*\(\)]{2,20}$/,
  };

  if (!verify[type]) return;

  if (retRegExp) return verify[type];

  return verify[type].test(content);
}

/**
 * 加密字符串
 * @param key，getPublicKey获得的密钥
 * @param value，被加密字符串
 * @returns {string}，加密后的文本
 */
export function doRsaEncrypt(key, value) {
  if (typeof window === "undefined") return;
  if (!key || !value) return value;
  const { JSEncrypt } = require("jsencrypt");
  const encrypt = new JSEncrypt();
  encrypt.setPublicKey(key);
  const encrypted = encrypt.encrypt(value);
  return encrypted;
}

/**
 * 将 text 文本复制到剪切板
 * @param text，需要复制的文本
 * 这个是同步函数，返回 true 说明复制成功，false 失败
 */
export function copy(text) {
  if (typeof window === "undefined") return;
  const ele = document.createElement("textarea");
  ele.readonly = "readonly";
  ele.style.position = "fixed";
  ele.style.opacity = "0";
  ele.style.width = "0";
  ele.style.height = "0";
  ele.value = text;
  document.body.appendChild(ele);
  ele.focus();
  //ele.select(); //not working in mobile
  ele.setSelectionRange(0, ele.value.length);
  const result = document.execCommand("copy");
  ele.parentNode.removeChild(ele);
  return result;
}

/**
 * 重定向，对满足条件的链接进行重定向
 * @router
 */

export function redirectBackUrl(
  router,
  {
    noElse = false, //如果 backurl 不符合条件，就没有下文了，否则重定向到默认地址
    method = "replace", //重定向方法
    defaultArgs = undefined, //默认重定向内容
  } = {}
) {
  const { backurl } = router.query;

  if (backurl) {
    const topDomain = getOrigin("", "none");
    const regExp = new RegExp(
      "^(http://|https://)(\\w+\\.)?" + topDomain + "($|/.*|\\?.*)",
      "i"
    );
    const isLegal = regExp.test(backurl); //是否为合法回调地址
    if (isLegal) {
      return router[method](backurl);
    }
  }

  if (noElse) return;

  router[method](defaultArgs || getOrigin("www"));
}

export function getExplore(){
  var Sys = {}; 
  var ua = navigator.userAgent.toLowerCase(); 
  var s; 
  (s = ua.match(/rv:([\d.]+)\) like gecko/)) ? Sys.ie = s[1] :
  (s = ua.match(/msie ([\d\.]+)/)) ? Sys.ie = s[1] : 
  (s = ua.match(/edge\/([\d\.]+)/)) ? Sys.edge = s[1] :
  (s = ua.match(/firefox\/([\d\.]+)/)) ? Sys.firefox = s[1] : 
  (s = ua.match(/(?:opera|opr).([\d\.]+)/)) ? Sys.opera = s[1] : 
  (s = ua.match(/chrome\/([\d\.]+)/)) ? Sys.chrome = s[1] : 
  (s = ua.match(/version\/([\d\.]+).*safari/)) ? Sys.safari = s[1] : 0; 
   // 根据关系进行判断
  if (Sys.ie) return ('IE V' + Sys.ie); 
  if (Sys.edge) return ('EDGE V' + Sys.edge);
  if (Sys.firefox) return ('Firefox V' + Sys.firefox); 
  if (Sys.chrome) return ('Chrome V' + Sys.chrome); 
  if (Sys.opera) return ('Opera V' + Sys.opera); 
  if (Sys.safari) return ('Safari V' + Sys.safari);
  return 'Unknown';
}

export function browserRedirect(){
  var sUserAgent = navigator.userAgent;
  var isWin = (navigator.platform == "Win32") || (navigator.platform == "Windows");
  var isMac = (navigator.platform == "Mac68K") || (navigator.platform == "MacPPC") || (navigator.platform == "Macintosh") || (navigator.platform == "MacIntel");
  if (isMac) return "Mac OS";
  var isUnix = (navigator.platform == "X11") && !isWin && !isMac;
  if (isUnix) return "Unix";
  var isLinux = (String(navigator.platform).indexOf("Linux") > -1);
  if (isLinux) return "Linux";
  if (isWin) {
      var isWin2K = sUserAgent.indexOf("Windows NT 5.0") > -1 || sUserAgent.indexOf("Windows 2000") > -1;
      if (isWin2K) return "Win2000";
      var isWinXP = sUserAgent.indexOf("Windows NT 5.1") > -1 || sUserAgent.indexOf("Windows XP") > -1;
      if (isWinXP) return "WinXP";
      var isWin2003 = sUserAgent.indexOf("Windows NT 5.2") > -1 || sUserAgent.indexOf("Windows 2003") > -1;
      if (isWin2003) return "Win2003";
      var isWinVista= sUserAgent.indexOf("Windows NT 6.0") > -1 || sUserAgent.indexOf("Windows Vista") > -1;
      if (isWinVista) return "WinVista";
      var isWin7 = sUserAgent.indexOf("Windows NT 6.1") > -1 || sUserAgent.indexOf("Windows 7") > -1;
      if (isWin7) return "Win7";
      var isWin10 = sUserAgent.indexOf("Windows NT 10") > -1 || sUserAgent.indexOf("Windows 10") > -1;
      if (isWin10) return "Win10";
  }
  return "Unknown";
}

export function getUUID(){
  let d = new Date().getTime();
  let uuid = 'xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      let r = (d + Math.random()*16)%16 | 0;
      d = Math.floor(d/16);
      return (c=='x' ? r : (r&0x3|0x8)).toString(16);
  });
  return uuid
}

/**
 * 根据当前顶级域名，获取二级域名链接
 * @param api，对应二级域名字符串，为空时返回顶级域名
 * @param noProtocol，获取链接默认是带有协议的，如果该字段存在，不包含协议
 *     如果 noProtocol === "ws" 会更加当前http协议添加 ws:// 或 wss://
 */
export function getOrigin1(api, noProtocolOrWs) {
	let host, protocol;
	if (typeof window === "undefined") {
		//server side
		host = process.env.NEXT_PUBLIC_host;
		protocol = process.env.NEXT_PUBLIC_protocol;
	} else {
		const isLocal =
			location.hostname === "localhost" ||
			/^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)(\.(?!$)|$)){4}$/.test(
				location.hostname
			) ||
			location.hostname.includes("test");

		host = isLocal ? process.env.NEXT_PUBLIC_host : location.host;
		protocol = isLocal ? process.env.NEXT_PUBLIC_protocol : location.protocol;
	}

	const topDomain = host.split(".").slice(-2).join(".");
	const domain = (api ? `${api}.` : "") + topDomain;
	if (!noProtocolOrWs) return `${protocol}//` + domain;
	if (noProtocolOrWs === "ws")
		return `${protocol.includes("https") ? "wss" : "ws"}://` + domain;
	return domain;
}

const { getUrl, getXTUrl } = Util;

export function toLoginBase() {
  const hasSearch = location.search;
  
	window.location.href = getUrl(
		`/accounts/login${hasSearch ? hasSearch + '&' : '?'}backurl=${encodeURIComponent(window.location.href)}`
	).replace("ko", "en");
}

export function toRegisterBase() {
  const hasSearch = location.search;

	window.location.href = getUrl(
		`/accounts/register${hasSearch ? hasSearch + '&' : '?'}backurl=${encodeURIComponent(window.location.href)}`
	).replace("ko", "en");
}

export function toLogoutBase() {
	window.location.href = `${getUrl("/")}`.replace("ko", "en");
}

export function getRootDomain() {
	let domain = document.domain; //先获取当前访问的全域名
	let domain2 = domain.substring(domain.indexOf(".") + 1); //截取第一个点的位置来获取根域名,这样只能获取二级域名的根域名，如果直接是不带www的域名访问，那么就会直接获取域名的后缀
	return domain2;
}

export const getFineLang = (lang) => (lang === "ko" ? "en" : lang);

export function getInviteUrl(inviteCode, lang) {
	return `${process.env.NEXT_PUBLIC_protocol}//www.${getRootDomain()}/${getFineLang(lang)}/accounts/register?ref=${inviteCode}`;
}

export function copyToClipboard(text) {
	return copy2(text);
}

export const downloadImage = (url, name) => {
	let image = new Image(); // 解决跨域 Canvas 污染问题

	image.onload = function () {
		let a = document.createElement("a"); // 生成一个a元素

		let event = new MouseEvent("click"); // 创建一个单击事件

		a.download = name || "photo"; // 设置图片名称

		a.href = url; // 将生成的URL设置为a.href属性

		a.dispatchEvent(event); // 触发a的单击事件

		document.removeChild(a);
	};

	image.src = url;
};

export function saveFileFromBlob(response, filename) {
	const fileNames = response.headers["content-disposition"];
	if (fileNames) {
		filename = decodeURIComponent(fileNames.match(/=(.*)$/)[1]);
	}
	const content = response.data;
	const blob = window.URL.createObjectURL(
		new Blob(
			[content]
			// ,{
			//   type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
			// }
		)
	);
	const aLink = document.createElement("a");
	aLink.style.display = "none";
	aLink.href = blob;
	aLink.download = filename;
	document.body.appendChild(aLink);
	aLink.click();
	window.URL.revokeObjectURL(aLink.href);
	document.body.removeChild(aLink);
}

/**
 * 获取url中search字段，譬如 getUrlSearchAttr('token')
 * @param regStr，属性字段
 * @param exact，是否精确匹配大小写
 * @param urlStr，如果存在，使用该字符串作为查找对象
 * @returns {string}，返回对应属性的值
 */
export function getUrlSearchAttr(regStr, exact, urlStr) {
	const { search } = window.location;

	let todoStr = search;
	if (urlStr && typeof urlStr === "string") {
		urlStr.indexOf("?") < 0 && (urlStr = "?" + urlStr);
		todoStr = urlStr;
	}

	const regExp = new RegExp("[?&]" + regStr + "=[^&]+", exact ? "g" : "gi");
	let value = "",
		temp;
	todoStr.replace(regExp, (str) => {
		temp = str.split("=")[1];
		temp && (value = decodeURIComponent(temp));
	});

	return value;
}

export const aryFilter = (ary, keyword, cfgObj) => {
  /**
   * 对数组进行模糊筛选查找，返回一个新的数组
   * ary {Array} 字符串或对象数组
   * keyword {String} 关键词
   * cfgObj = { //可选
   *     maxLen: 512, //字符串长度不小于该值不校验
   *     attrAry: ['attrA', 'attrB'], //需要校验的属性数组，默认无，全部校验
   *     attrAryDark: false, //黑名单，即校验上述数组不包含的属性
   *     attrFunc: {
   *         attrA: (attrVal, reg, keyword) => {}, //返回 truthy 即新增
   *     },
   *     regAttr: false, //是否校验对象属性
   * }
   */

  if (!keyword) return ary;
  const reg = regExpQuote(keyword, 1, "i");
  cfgObj = {
    maxLen: 512, //字符串长度不小于该值不校验
    regAttr: true, //是否校验对象属性
    attrFunc: {},
    ...(cfgObj || {}),
  };

  const newAry = [];
  ary.map((tar) => {
    if (typeof tar === "object") {
      for (let va in tar) {
        if (cfgObj.attrAry) {
          if (cfgObj.attrAryDark) {
            if (cfgObj.attrAry.indexOf(va) >= 0) continue;
          } else {
            if (cfgObj.attrAry.indexOf(va) < 0) continue;
          }
        }

        if (cfgObj.attrFunc[va]) {
          if (cfgObj.attrFunc[va](tar[va], reg, keyword))
            return newAry.push(tar);
        } else {
          if (cfgObj.regAttr) {
            if (va.length < cfgObj.maxLen && reg.test(va))
              return newAry.push(tar);
          }

          if (tar[va].length < cfgObj.maxLen && reg.test(tar[va]))
            return newAry.push(tar);
        }
      }
    } else if (tar.length < cfgObj.maxLen && reg.test(tar)) {
      newAry.push(tar);
    }
  });

  return newAry;

  function regExpQuote(str, retReg, regArg) {
    //剔除正则表达式中的引用值
    const newStr = str.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
    if (!retReg) return newStr;
    return new RegExp(newStr, regArg);
  }
};

export const gotoDownloadApp = () => {
  window.location.href = window.location.origin + "/app";
};

export const gotoApp = (path = "") => {
  if (window) {
    if (Platform.isInApp()) {
      if (Bridge && Bridge.call) {
        Bridge.call("appRoute", { path, params: "" });
      }
    } else {
      const timer = setTimeout(() => {
        window.location.href = window.location.origin + "/app";
      }, 3000);

      // window.location.href = "[scheme:][//authority][path][?query][#fragment]";
      window.location.href = `xtappinternal://xtapp.com${path}`;

      window.addEventListener("visibilitychange", () => {
        if (document.hidden) {
          // 唤起成功
          clearTimeout(timer);
        }
      });
    }
  }
};


export const getDomain = () => {
  if (typeof window == 'undefined') {
    if (process.env.NODE_ENV != 'production') return 'spikex.com';
    else return 'spikex.com';
  } else {
    const isLocal =
      location.hostname === 'localhost' || /^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)(\.(?!$)|$)){4}$/.test(location.hostname);
    // if (document.domain.includes('localhost'))
    if (isLocal) return location.port == '80' ? 'localhost' : 'spikex.com';
    else
      return document.domain
        .split('.')
        .slice(-2)
        .join('.');
  }
};

export const getXTOrigin = () => {
  if (typeof window != 'undefined' && !document.domain.includes('spikex.com') && !document.domain.includes('spikex.com')) {
    // return `${location.protocol}//${document.domain}`;
    return `${location.protocol}//${document.domain}:${location.port}`;
  }

  const { protocol } = typeof window == 'undefined' ? { protocol: 'http:' } : window.location;
  const domain = getDomain();

  return domain.startsWith('localhost') ? `${protocol}//${domain}` : `${protocol}//www.${domain}`;
};
export const getBrowserInterfaceSize = () => {
  if (window) {
    let pageWidth = window.innerWidth;
    let pageHeight = window.innerHeight;
    if (typeof pageWidth != "number") {
      if (document.compatMode == "CSS1Compat") {
        pageWidth = document.documentElement.clientWidth;
        pageHeight = document.documentElement.clientHeight;
      } else {
        pageWidth = document.body.clientWidth;
        pageHeight = window.body.clientHeight;
      }
    }

    return { width: `${pageWidth}px`, height: `${pageHeight}px` };
  }

  return { width: "auto", height: "auto" };
};

// 获取精度
// cny 2 usd 4 btc 8 inr 2 Idr 2
export const getPrecision = (key) => {
  const obj = {
    cny: 2,
    usd: 2,
    btc: 8,
    inr: 2,
    idr: 2,
  };

  return obj[key] || 0;
};

export async function getCommonStaticProps(context, PagePath="/app") {
  const resolvedUrl = PagePath;
  const props = {resolvedUrl, theme:"dark"};
  try{
    const tdkUrl = getOrigin("www") + "/" + context.locale + resolvedUrl;
    const tdk = await get_tdk({
      params: {
        url: tdkUrl,
        languageType: context.locale == "zh-CN" ? "cn" : context.locale == "zh-HK" ? "hk" : context.locale
      },
    });
    props.tdk = tdk || {};
  }
  catch(error)
  {
    console.log("get tdk error");
    console.log(error);
    props.tdk = {};
  }
  return {
    props,
    revalidate:60
  }
}
// 替换url
export function getNewUrl(url) {
  return replaceUrlParameter(url);
}

export function replaceUrlParameter(url) {
  const lang = Cookie.get('lang');
  const { fund } = useStore()
  const params = {
    __h5host__: getOrigin(null, true),
    __pathLang__: localeMap && localeMap.find((item) => item.key == lang)?.name || "en",
    __lang__: lang,
    __currency__: fund.assist?.key || "usd"
  };

  const reg = new RegExp(`(${Object.keys(params).join("|")})`, "g");
  return url.replace(reg, (attr) => params[attr]);
}


/**
 * 节流
 * @param {*} fn 将执行的函数
 * @param {*} time 节流规定的时间
 */
export const throttle = (fn, time) => {
  let timer = null
  return (...args) => {
    // 若timer === false，则执行，并在指定时间后将timer重制
    if(!timer){
      fn.apply(this, args)
      timer = setTimeout(() => {
        timer = null
      }, time)
    }
  }
}

export const animate = {
  easeIn: function (t, b, c, d) {
    if (t >= d) t = d
    return c * (t /= d) * t + b
  },
  easeOut: function (t, b, c, d) {
    if (t >= d) t = d
    return -c * (t /= d) * (t - 2) + b
  }
}

export const getZenLang = () => {
  const lang = XtLocale.getZenLan();

  return lang;
};

/** Zendesk widget 语言：默认英文，禁止中文，与 ssr-web-trade 一致 */
export function getZendeskLocale(zenLan) {
  if (!zenLan || typeof zenLan !== "string") return "en";
  const locale = zenLan.toLowerCase().replace(/_/g, "-");
  if (locale.startsWith("zh")) return "en";
  return locale;
}

export function getOneByThreeStatus(obj, value) {
  const valueFormat = +(value || 0) || 0;
  if (valueFormat > 0) return obj.gt;
  if (valueFormat < 0) return obj.lt;
  return obj.eq;
}

export function getServerSideDomain(arg) {
  let domain = arg.inner;
  if (process.env.NEXT_PUBLIC_LOCAL) {
    if (arg.noLocalDomain) {
      domain = arg.local;
    } else {
      domain = process.env.NEXT_PUBLIC_protocol + "//" + process.env.NEXT_PUBLIC_host + arg.local;
    }
  }
  return domain;
}

export function eleResizeObserver(ele, callback) {
  try {
    const resizeObserver = new ResizeObserver((entries) => {
      callback(entries[0].target);
    });
    resizeObserver.observe(ele || document.documentElement);
  } catch (e) {
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.zIndex = "-1";
    iframe.style.top = "0";
    iframe.style.bottom = "0";
    iframe.style.left = "0";
    iframe.style.height = "100%";
    iframe.style.width = "100%";
    iframe.style.border = "none";
    iframe.style.opacity = "0";
    iframe.style.background = "transparent";
    (ele || document.body).appendChild(iframe);
    iframe.contentWindow.onresize = function (event) {
      callback(event.target.document.documentElement);
    };
  }
}

export function getUpDownCls(value, ret3Mode) {
  const valueFormat = +(value || 0) || 0;
  if (!valueFormat) return ret3Mode ? undefined : "down-color";
  return valueFormat > 0 ? "up-color" : "down-color";
}

export function thousands(strOrNum) {
  const ary = ((strOrNum || 0) + "").split(".");
  const retAry = [ary[0].replace(/\d(?=(\d{3})+$)/g, "$&,")];
  if (ary[1]) retAry.push(ary[1]);
  return retAry.join(".");
}

export function upperCaseFirstLetter(str) {
  if (!str) return str;
  return str[0].toUpperCase() + str.slice(1).toLowerCase();
}

export function filterBigNumThousands(strOrNum, precision) {
  if (+strOrNum >= 1e7) {
    if (+strOrNum - 1e9 >= 0) {
      return Big(strOrNum || 0).div(1e9).toFixedMaxCy(3) + "B";
    }
    if (+strOrNum - 1e6 >= 0) {
      return Big(strOrNum || 0).div(1e6).toFixedMaxCy(3) + "M";
    }
    if (+strOrNum - 1e3 >= 0) {
      return Big(strOrNum || 0).div(1e3).toFixedMaxCy(3) + "K";
    }
  }

  if ((precision && precision > 0) || precision === 0) {
    return Big(strOrNum || 0).toFixedCy(precision);
  }

  return thousands(strOrNum);
}

export function disposePrecision(value, point = 3) {
  let str = "";
  for (let i = 1; i < point; i++) {
    str += 0;
  }
  str += "1";
  str = "0." + str;

  const minus001 = (value ? +value : 0) - +str;
  if (minus001 >= 0) {
    return Big(value || 0).toFixedCy(point);
  }
  return Big(value || 0).toFixedMax(8);
}

export function routerPush(router, { method = "push", symbol, isLever, isCfd }) {
  const pathname = router.pathname || "";
  // Prop 交易页：交易对拼在路由上 /proptrading/trade/{symbol}，与 /futures/contract/{symbol} 一致
  if (
    isCfd &&
    !isLever &&
    symbol &&
    (pathname === "/proptrading/trade" || pathname === "/proptrading/trade/[symbol]")
  ) {
    router[method](`/proptrading/trade/${symbol}`, undefined, { shallow: true });
    return;
  }
  const query = isLever ? "?type=margin" : "";
  const basePath = isCfd ? "/futures/contract" : "/trade";
  router[method](basePath + "/" + symbol + query, undefined, { shallow: true });
}

export function getChildrenSlot(children) {
  const eleAry = (() => {
    if (!children) return [];
    if (children instanceof Array) return children;
    if (typeof children === "object") return [children];
    return [];
  })();

  return eleAry.reduce((slots, item) => {
    if (item?.props?.slot) slots[item.props.slot] = item;
    return slots;
  }, {});
}
